import { Reducer } from 'redux';
import { ProgressBarSLAState, ProgressBarSLATypes } from './types';

const INITIAL_STATE: ProgressBarSLAState = {
  data: [],
  loading: false,
  error: false,
};

const reducer: Reducer<ProgressBarSLAState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ProgressBarSLATypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ProgressBarSLATypes.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload.data,
      };
    case ProgressBarSLATypes.LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        data: [],
      };
    default:
      return state;
  }
};

export default reducer;
